const PRIMARY_MAIN = '#CB5E3C'

export function hexToRgba(hexColor, alpha) {
  let hex = hexColor.replace('#', '')
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(c => c + c)
      .join('')
  }
  const num = parseInt(hex, 16)
  const red = (num >> 16) & 255
  const green = (num >> 8) & 255
  const blue = num & 255
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

export const buildPalette = (primaryHex = PRIMARY_MAIN) => {
  return {
    mode: 'light',
    primary: {
      main: primaryHex,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: hexToRgba(primaryHex, 0.15),
    },
    custom: {
      border: '#b5b5b5',
    },
  }
}

export const palette = buildPalette(PRIMARY_MAIN)

// Map colors like this as theme gets developed
// info: {
//     main: "#17a2b8",
//     dark: "#117a8b",
//     light: "#3db5c9",
//     contrastText: "#ffffff"
//   },
//   grey: {
//     50: "#f8f9fa",
//     100: "#e9ecef",
//   },
//   background: {
//     default: "#ffffff",
//     paper: "#ffffff"
//   },
//   text: {
//     primary: "#212529",
//     secondary: "#6c757d",
//     disabled: "#adb5bd"
//   },
//   divider: "#dee2e6",
//   action: {
//     active: "#495057",
//     hover: "rgba(0, 0, 0, 0.04)",
//     selected: "rgba(0, 0, 0, 0.08)",
//     disabled: "rgba(0, 0, 0, 0.26)",
//     disabledBackground: "rgba(0, 0, 0, 0.12)"
//   }
